import { PlusOutlined } from "@ant-design/icons";
import { TableList } from "@components/TableList/TableList";
import { ROW_GUTTER } from "@constants";
import { Button, Col, ConfigProvider, Form, Row, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import { FormInstance } from "antd/lib";
import { useTranslation } from "react-i18next";
import { CommonMasterWrapper } from "./CommonMasterPageStyled";

type TCommonMasterPageProps = {
  pageName: string;
  form: FormInstance;
  listItems: any[];
  listData: any[];
  columns: any[];
  rowKey: number | null;
  commonName: string;
  tableRef?: any;
  isDisableSearchBtn?: boolean;

  // Functions
  handleSearch: (val: any) => void;
  handleOpenRegisModal: (val: any) => void;
  handleScroll: (e: any) => void;
  handleClearSearch?: () => void;
};

function CommonMasterPage(props: TCommonMasterPageProps) {
  const { t } = useTranslation();
  const {
    pageName,
    form,
    listItems,
    columns,
    listData,
    rowKey,
    commonName,
    tableRef,

    // Functions
    handleScroll,
    handleSearch,
  } = props;

  return (
    <CommonMasterWrapper>
      <Content className="common-master-page-header">
        <Typography className="common-master-page-header_title">
          {t(`${pageName}.PAGE_TITLE`)}
        </Typography>
      </Content>
      <Content className="common-master-page-body">
        <Form
          onFinish={handleSearch}
          form={form}
          layout="vertical"
          name="common-master-page-search-form"
        >
          <ConfigProvider
            theme={{
              components: {
                Select: {
                  optionSelectedBg: "var(--color-hover-primary) !important",
                },
              },
            }}
          >
            <Row
              gutter={[ROW_GUTTER.HORIZONTAL, ROW_GUTTER.VERTICAL]}
              style={{ padding: "16px" }}
            >
              <Col span={21} />
              <Col span={3}>
                <Button
                  onClick={props.handleOpenRegisModal}
                  icon={<PlusOutlined />}
                  className="common-master-page-body_btn"
                >
                  {t(`${commonName}.BTN_REGISTRATION`)}
                </Button>
              </Col>
            </Row>
            <Row
              gutter={[ROW_GUTTER.HORIZONTAL, ROW_GUTTER.VERTICAL]}
              style={{ padding: "16px", marginTop: "-20px" }}
              align="middle"
            >
              {listItems.map((item, index) => {
                return (
                  <Col key={index} span={3}>
                    <Form.Item {...item.fieldConfig}>{item.element}</Form.Item>
                  </Col>
                );
              })}

              <Col span={2}>
                {props.isDisableSearchBtn ? (
                  <Button
                    className="common-master-page-body__search-btn-disable"
                    disabled
                    autoInsertSpace={false}
                  >
                    {t("COMMON.SEARCH")}
                  </Button>
                ) : (
                  <Button
                    className="common-master-page-body__search-btn"
                    htmlType="submit"
                    autoInsertSpace={false}
                  >
                    {t("COMMON.SEARCH")}
                  </Button>
                )}
              </Col>
              <Col span={2}>
                <Button
                  className="common-master-page-body__clear-btn"
                  onClick={props.handleClearSearch}
                  autoInsertSpace={false}
                >
                  {t("COMMON.CLEAR")}
                </Button>
              </Col>
            </Row>
          </ConfigProvider>
        </Form>
        <div className="common-master-page-table">
          <TableList
            tableRef={tableRef}
            handleScroll={handleScroll}
            listData={listData}
            columns={columns}
            rowKey={rowKey}
            messageNoData={t("COMMON_MSG.NO_RESULT_MSG")}
            heightTableScroll={685}
            borderColor="var(--color-border-primary)"
            image=""
          />
        </div>
      </Content>
    </CommonMasterWrapper>
  );
}

export { CommonMasterPage };
